import IconButton from "@mui/material/IconButton";
import { cloneElement, useRef } from "react";
import { useButton, useOverlayTrigger } from "react-aria";
import {
  OverlayTriggerProps as StatelyOverlayTriggerProps,
  useOverlayTriggerState,
} from "react-stately";
import { styled } from "styled-components";
import { Icon } from "@mindlercare/ui-web";
import { Popover } from "./Popover";
import { CircledNumber } from "./CircledNumber";

type PopoverTriggerProps = StatelyOverlayTriggerProps & {
  children: React.ReactElement;
  label: string;
  placement: "bottom" | "top" | "left" | "right";
  crossOffset: number;
  numberOfNotifications: number;
};

const DesignProofIconButton = styled(IconButton)`
  width: 84px;
  height: 36px;
  border-radius: 70px;
  &:hover {
    background-color: ${({ theme }) => theme.COLORS.GRAY_LIGHT} !important;
  }
`;

export const PopoverTrigger = ({
  label,
  children,
  numberOfNotifications,
  ...props
}: PopoverTriggerProps) => {
  const ref = useRef(null);
  const state = useOverlayTriggerState(props);
  const { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    state,
    ref,
  );
  const { buttonProps } = useButton(triggerProps, ref);

  return (
    <>
      <DesignProofIconButton
        {...buttonProps}
        ref={ref}
        color="default"
        disableFocusRipple
        aria-label={label}
      >
        <Icon.Notifications />
        <CircledNumber number={numberOfNotifications} />
      </DesignProofIconButton>
      {state.isOpen && (
        <Popover {...props} triggerRef={ref} state={state}>
          {cloneElement(children, {
            ...overlayProps,
            onClose: state.close,
          })}
        </Popover>
      )}
    </>
  );
};
